import React from "react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "../../../containers/settings/settingsEditCommon.css";
import { IWorkingWeek } from "../../../models/currentUser/CurrentUserStore";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { SubtitleDescription } from "../subtitleDescription";
import { WorkingHoursContainer } from "./workingHoursContainer";
import { AppPermission } from "@closerplatform/spinner-openapi";

interface Props {
  workingHours: IWorkingWeek;
  zoneId: string;
}

export const WorkingHoursSettings: React.SFC<Props> = withPermissionFallback(
  AppPermission.SettingsGeneral,
  ({ workingHours, zoneId }) => (
    <>
      <div className={styles.title}>
        <L10n id={"settings.admin.workingHours"} />
      </div>
      <div className={styles.section}>
        <SubtitleDescription
          subtitle={intl.formatMessage("settings.workingHours.companyWorkingHours")}
          description={intl.formatMessage("settings.workingHours.companyWorkingHours.description")}
        />
        <WorkingHoursContainer workingHours={workingHours} zoneId={zoneId} />
      </div>
    </>
  )
);
